<template>
  <div class="user-action-table-cell">
    <div class='user-action-table-cell__edit-btn' :class="{'disable': isDisabled}" @click="editUser" @mouseenter='editMouseEnter' v-if="this.item.role">
      <custom-tooltip popper-class="light-tooltip">
        <div slot='buttonContent'>
            <lottie-animation
              class='edit-animation'
              ref="editAnimation"
              :loop='true'
              :animationData="require('@/assets/icons/animations/edit.json')"
              @loopComplete="editLoopComplete"
            />
          </div>
        <div slot="content">
          <slot name="tooltip">
            <span>Edit</span>
          </slot>
        </div>
      </custom-tooltip>
    </div>
    <div class='user-action-table-cell__reset-btn' :class="{'disable': isDisabled}" @click="resetPassword" @mouseenter='resetMouseEnter' v-if="this.item.role">
      <custom-tooltip popper-class="light-tooltip">
        <div slot='buttonContent'>
            <lottie-animation
              class='reset-animation'
              ref="resetAnimation"
              :loop='true'
              :animationData="require('@/assets/icons/animations/reset-password.json')"
              @loopComplete="resetLoopComplete"
            />
          </div>
        <div slot="content">
          <slot name="tooltip">
            <span>Reset Password</span>
          </slot>
        </div>
      </custom-tooltip>
    </div>
    <div class='user-action-table-cell__resend-btn' :class="{'disable': isDisabled}" @click="resendInvite" @mouseenter='resendMouseEnter' v-if="!this.item.role">
      <custom-tooltip popper-class="light-tooltip">
        <div slot='buttonContent'>
          <lottie-animation
            class='resend-animation'
            ref="resendAnimation"
            :loop='true'
            :animationData="require('@/assets/icons/animations/resend.json')"
            @loopComplete="resendLoopComplete"
          />
        </div>
        <div slot="content">
          <slot name="tooltip">
            <span>Resend Invite</span>
          </slot>
        </div>
      </custom-tooltip>
    </div>
    <div class='user-action-table-cell__delete-btn' :class="{'disable': isDisabled}" @click="deleteUser" @mouseenter='deleteMouseEnter'>
      <custom-tooltip popper-class="light-tooltip">
        <div slot='buttonContent'>
            <lottie-animation
              class='delete-animation'
              ref="deleteAnimation"
              :loop='true'
              :animationData="require('@/assets/icons/animations/delete.json')"
              @loopComplete="deleteLoopComplete"
            />
          </div>
        <div slot="content">
          <slot name="tooltip">
            <span>Delete</span>
          </slot>
        </div>
      </custom-tooltip>
    </div>
  </div>
</template>

<script>
import LottieAnimation from 'lottie-web-vue';
import {mapGetters} from 'vuex';
import CustomTooltip from '@/components/common/CustomTooltip.vue';

export default {
  name: 'ActionTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  components: {
    LottieAnimation,
    CustomTooltip,
  },
  computed: {
    ...mapGetters(['disableDeleteUserButton']),
    isDisabled() {
      return this.disableDeleteUserButton.size > 0 ? this.disableDeleteUserButton?.has(this.item.id) : false;
    },
  },
  methods: {
    async deleteUser() {
      await this.$emit('deleteUser', this.item);
    },
    async editUser() {
      await this.$emit('editUser', this.item);
    },
    async resetPassword() {
      await this.$emit('resetPassword', this.item);
    },
    async resendInvite() {
      await this.$emit('resendInvite', this.item.email);
    },
    editMouseEnter() {
      this.$refs.editAnimation.play();
    },
    editLoopComplete() {
      this.$refs.editAnimation.pause();
    },
    deleteMouseEnter() {
      this.$refs.deleteAnimation.play();
    },
    deleteLoopComplete() {
      this.$refs.deleteAnimation.pause();
    },
    resetMouseEnter() {
      this.$refs.resetAnimation.play();
    },
    resetLoopComplete() {
      this.$refs.resetAnimation.pause();
    },
    resendMouseEnter() {
      this.$refs.resendAnimation.play();
    },
    resendLoopComplete() {
      this.$refs.resendAnimation.pause();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/styles/variables";

.user-action-table-cell {
  align-items: center;
  justify-content: flex-end;
  display: var(--displayactioncell) !important;
  .disable {
    opacity: 0.5;
    pointer-events: none;
  }
  &__delete-btn, &__edit-btn, &__reset-btn, &__resend-btn {
    z-index: 10;
    align-items: center;
    background-color: var(--btn-good-bg, rgba(36, 190, 181, 0.2));
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    height: 32px;
    justify-content: center;
    width: 32px;
    min-width: 32px;
    min-height: 32px;
    color: $default-fill-color !important;
    margin-left: 15px;
    &:hover {
      cursor: pointer;
      border: 1px solid var(--btn-good-border-color, #24BEB5);
      background-color: var(--btn-good-hover-bg, rgba(36, 190, 181, 0.1)) !important;
    }
    &:active{
      border: 1px solid var(--btn-good-border-color, #24BEB5);
      background-color: var(--btn-good-hover-bg, rgba(36, 190, 181, 0.1)) !important;
    }
    .delete-animation, .edit-animation, .reset-animation {
      height: 30px;
    }
    .resend-animation {
      height: 26px;
    }
  }
  &__delete-btn {
    background-color: var(--btn-action-bg, rgba(179, 49, 207, 0.3));
    &:hover {
      cursor: pointer;
      border: 1px solid var(--btn-action-border-color, #B331CF);
      background-color: var(--btn-action-hover-bg, rgba(179, 49, 207, 0.1)) !important;
    }
    &:active{
      border: 1px solid var(--btn-action-border-color, #B331CF);
      background-color: var(--btn-action-hover-bg, rgba(179, 49, 207, 0.1)) !important;
    }
  }
}
</style>
